import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { renovacao_serie_compara } from "../../services/api";

const Fidelizacao_serie_comparativa = (props) => {
    const [dataTotal, setDataTotal] = useState([]);
    const [isloading, setIsloading] = useState(true);

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await renovacao_serie_compara();
            setDataTotal(response.data || []);
            console.log("Dados recebidos:", response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        switch (seg) {
            case '0-1': return 'Mat 1';
            case '0-2': return 'Mat 2';
            case '0-3': return 'Pré 1';
            case '0-4': return 'Pré 2';
            case '1-1': return '1º Fund I';
            case '1-2': return '2º Fund I';
            case '1-3': return '3º Fund I';
            case '1-4': return '4º Fund I';
            case '1-5': return '5º Fund I';
            case '1-6': return '6º Fund II';
            case '1-7': return '7º Fund II';
            case '1-8': return '8º Fund II';
            case '1-9': return '9º Fund II';
            case '2-1': return '1ª Médio';
            case '2-2': return '2ª Médio';
            case '2-3': return '3ª Médio';
            default: return seg;
        }
    };

    // Função para replicar a formatação condicional de EV 26 e EV 25
    const getEvasaoStyle = (value) => {
        if (value >= 0 && value < 25) return { backgroundColor: "green", color: "white" };
        if (value >= 25 && value < 40) return { backgroundColor: "orange", color: "white" };
        if (value >= 40 && value < 50) return { backgroundColor: "red", color: "white" };
        if (value >= 50 && value < 75) return { backgroundColor: "darkred", color: "white" };
        if (value >= 75 && value <= 100) return { backgroundColor: "black", color: "white" };
        return {};
    };

    // Função para replicar a formatação condicional da Variação
    const getVariacaoStyle = (value) => {
        if (value > 0) return { backgroundColor: "red", color: "white" }; // Evasão aumentou
        if (value < 0) return { backgroundColor: "green", color: "white" }; // Evasão diminuiu
        return {};
    };

    // Variáveis para calcular o total geral da rede (se desejar mostrar no rodapé)
    let totalPR26 = 0, totalEVNum26 = 0;
    let totalPR27 = 0, totalEVNum27 = 0;

    // Processando os dados caso não esteja carregando
    let processedData = [];
    if (!isloading) {
        processedData = dataTotal.map(item => {
            const pr26 = parseFloat(item.pr_26) || 0;
            const evNum26 = parseFloat(item.evasao_26) || 0;
            const ev26 = pr26 > 0 ? (evNum26 * 100) / pr26 : 0;

            const pr27 = parseFloat(item.pr_27) || 0;
            const evNum27 = parseFloat(item.evasao_27) || 0;
            const ev27 = pr27 > 0 ? (evNum27 * 100) / pr27 : 0;

            const variacao = ev27 - ev26;
            let seta = '';
            if (ev27 < ev26) { seta = '🟢 ↓'; }
            else if (ev27 > ev26) { seta = '🔴 ↑'; }
            else { seta = '-'; }

            // Somando pros totais
            totalPR26 += pr26;
            totalEVNum26 += evNum26;
            totalPR27 += pr27;
            totalEVNum27 += evNum27;

            return {
                segmento: convertSegmento(item.serie),
                ev27,
                ev26,
                variacao,
                seta
            };
        });
    }

    // Calculando as porcentagens do Total Geral
    const totalEv27Perc = totalPR27 > 0 ? (totalEVNum27 * 100) / totalPR27 : 0;
    const totalEv26Perc = totalPR26 > 0 ? (totalEVNum26 * 100) / totalPR26 : 0;
    const totalVariacao = totalEv27Perc - totalEv26Perc;
    let totalSeta = '';
    if (totalEv27Perc < totalEv26Perc) totalSeta = '🟢 ↓';
    else if (totalEv27Perc > totalEv26Perc) totalSeta = '🔴 ↑';
    else totalSeta = '-';

    return (
        <div className="media mt-3 Evasao">
            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered size="sm" className="text-center align-middle bg-white m-0 small">
                    <thead className="table-dark text-nowrap">
                        <tr>
                            <th className="align-middle text-start ps-3">SEGMENTO</th>
                            <th className="align-middle">EV 27</th>
                            <th className="align-middle">EV 26</th>
                            <th className="align-middle">Variação</th>
                            <th className="align-middle">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isloading ? (
                            <tr>
                                <td colSpan="5" className="text-center py-4 text-muted">Carregando dados...</td>
                            </tr>
                        ) : (
                            processedData.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="text-start fw-bold bg-light ps-3">
                                        {row.segmento}
                                    </td>
                                    <td style={{ ...getEvasaoStyle(row.ev27), fontWeight: '500' }}>
                                        {row.ev27.toFixed(2)}%
                                    </td>
                                    <td style={{ ...getEvasaoStyle(row.ev26), fontWeight: '500' }}>
                                        {row.ev26.toFixed(2)}%
                                    </td>
                                    <td style={{ ...getVariacaoStyle(row.variacao), fontWeight: 'bold' }}>
                                        {row.variacao > 0 ? '+' : ''}{row.variacao.toFixed(2)}%
                                    </td>
                                    <td className="bg-light fw-bold" style={{ fontSize: '0.8em' }}>
                                        {row.seta}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                    {!isloading && processedData.length > 0 && (
                        <tfoot className="fw-bolder border-top border-dark">
                            <tr className="bg-light">
                                <td className="text-start ps-3">TOTAL GERAL</td>
                                <td style={getEvasaoStyle(totalEv27Perc)}>
                                    {totalEv27Perc.toFixed(2)}%
                                </td>
                                <td style={getEvasaoStyle(totalEv26Perc)}>
                                    {totalEv26Perc.toFixed(2)}%
                                </td>
                                <td style={getVariacaoStyle(totalVariacao)}>
                                    {totalVariacao > 0 ? '+' : ''}{totalVariacao.toFixed(2)}%
                                </td>
                                <td style={{ fontSize: '0.8em' }}>
                                    {totalSeta}
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </Table>
            </div>
        </div>
    );
};

export default Fidelizacao_serie_comparativa;